<template>
  <div class="drawer">
    <el-drawer
      size="711px"
      title="优惠券详情"
      :visible.sync="drawerStatus"
      @close="handleClose"
    >
      <div style="padding-bottom: 40px">
        <el-row class="row">
          <el-col :span="12">
            <span class="label">优惠券名称：</span>
            <span class="value">{{ curItem.coupon_name }}</span>
          </el-col>
          <el-col :span="12">
            <span class="label">核销码：</span>
            <span class="value">
              <span style="margin-right: 10px">{{ curItem._no }}</span>
              (
              <span v-if="curItem.use_status === 0">不可用</span>
              <span v-if="curItem.use_status === 1">未使用</span>
              <span v-if="curItem.use_status === 2">已使用</span>
              <span v-if="curItem.use_status === 3">已过期</span>
              )
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12">
            <span class="label">类别：</span>
            <span class="value">
              <span>{{ curItem.category_info.name }}</span>
            </span>
          </el-col>
          <el-col :span="12">
            <span class="label">满减规则：</span>
            <span class="value">
              <span v-if="curItem.activity_type == 1"
                >满 {{ curItem.money_top }}元 减{{
                  curItem.money_reduce
                }}元</span
              >
              <span v-if="curItem.activity_type == 2"
                >满 {{ curItem.rebate_top }} 元打{{ curItem.rebate }}折</span
              >
              <span v-if="curItem.activity_type == 3">抵扣</span>
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12">
            <span class="label">领取时间：</span>
            <span class="value">
              <span>{{
                $public.FTime(curItem.receive_time, "YYYY-MM-DD")
              }}</span>
            </span>
          </el-col>
          <el-col :span="12">
            <span class="label">有效期：</span>
            <span class="value">
              {{ $public.FTime(curItem.use_start_time, "YYYY-MM-DD") }} 到
              {{ $public.FTime(curItem.use_end_time, "YYYY-MM-DD") }}
            </span>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12">
            <span class="label">使用门店：</span>
            <span class="value" v-if="curItem.use_status == 2">
              {{ $public.getShopNameById(curItem.use_shop_id) || "--" }}
            </span>
          </el-col>
          <el-col :span="12">
            <span class="label">使用时间：</span>
            <span class="value" v-if="curItem.use_status == 2">
              {{
                $public.FTime(curItem.use_time, "YYYY-MM-DD HH:mm:ss") || "--"
              }}
            </span>
          </el-col>
        </el-row>
      </div>
      <div
        v-if="curItem.apply_range"
        style="
          font-size: 18px;
          color: #333;
          padding-left: 20px;
          padding-bottom: 12px;
          font-weight: 600;
        "
      >
        优惠项目
      </div>
      <div class="couponList" v-if="curItem.apply_range">
        <div v-show="curItem.apply_range.apply_type == 1">
          <div class="copunTitle">订单类型</div>
          <div class="boxCont">
            <span v-for="item in orderList" :key="item.id" style="margin: 10px">
              <el-tag>{{ item.name }}</el-tag>
            </span>
          </div>
        </div>
        <div v-show="curItem.apply_range.apply_type == 2">
          <div class="copunTitle">指定商品</div>
          <el-table
            :data="curItem.apply_range.product_list"
            style="width: 100%"
          >
            <el-table-column prop="goods_name" label="名称"> </el-table-column>
            <el-table-column label="规格">
              <template slot-scope="scope">
                <div>
                  {{ scope.row.sku_value || "----" }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-show="curItem.apply_range.apply_type == 3">
          <div class="copunTitle">指定分类</div>
          <div class="boxCont">
            <span
              v-for="item in curItem.apply_range.category_list"
              :key="item.id"
              style="margin: 10px 10px; display: inline-block"
            >
              <el-tag>{{ item.name }}</el-tag>
            </span>
          </div>
        </div>
        <div v-show="curItem.apply_range.apply_type == 4">
          <div class="copunTitle">指定活体</div>
          <div class="boxCont">
            <span
            v-for="item in curItem.apply_range.product_list"
            :key="item.id"
            style="margin: 10px"
          >
            <el-tag>{{ item.goods_name }}</el-tag>
          </span>
          </div>
          
        </div>
        <div v-show="curItem.apply_range.apply_type == 5">
          <div class="copunTitle">指定套餐</div>
          <el-table
            :data="curItem.apply_range.product_list"
            style="width: 100%"
          >
            <el-table-column prop="goods_name" label="名称"> </el-table-column>
            <el-table-column label="类别">
              <template>
                <div>
                  {{ "医疗服务" }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import { getTypeList } from "@/api/productApi.js";
export default {
  data() {
    return {
      drawerStatus: false,
      tableData: [], // 可用商品列表
      brandData: [], //可用订单
      orderList: [],
    };
  },
  computed: {},
  props: {
    curItem: {
      default: () => {
        return {};
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.drawerStatus = true;
      console.log(this.curItem, "详情--------------");
      if (!this.$public.isNull(this.curItem.voucher_detail)) {
        this.tableData = this.curItem.voucher_detail.product_list;
      }
    });
    if (this.curItem.apply_range.apply_type == 1) {
      this.getTypeArr();
    }
  },
  methods: {
    //获取订单列表
    getTypeArr() {
      getTypeList().then((res) => {
        if (res.code == 0) {
          console.log(this.curItem.apply_range.category_list);
          let arr = [];
          this.brandData = res.data;
          // curItem.apply_range.category_list
          this.brandData.forEach((item) => {
            this.curItem.apply_range.order_type.forEach((itemb) => {
              console.log(itemb, "item");
              if (itemb == Number(item.id)) {
                arr.push(item);
              }
            });
          });
          this.orderList = arr;
        }
      });
    },
    handleClose() {
      this.$emit("submit", { type: "close" });
    },
  },
};
</script>

<style scoped lang="scss">
.drawer {
  width: 0;
  padding: 0 0 0 0;
  ::v-deep.el-drawer {
  }
  .couponList {
    padding: 14px 20px;
    .boxCont {
      border: 1px solid #ccc;
      border-radius: 8px;
      padding: 10px;
    }
    .copunTitle {
      margin: 14px 20px;
    }
  }
  .row {
    padding: 14px 20px 14px;
    float: none;
    font-size: 20px;
    font-size: 12px;
    color: #666;
    border-bottom: 1px solid #f2f2f2;
    .label {
      display: inline-block;
      width: 90px;
      text-align: right;
    }
  }
}
</style>
